import { styled } from '@mui/system';

import { ChkStatusScreen } from '../ChkStatusScreen/ChkStatusScreen';

import type { ChkGenericLoaderProps } from './ChkGenericLoader.types';

export const ChkGenericLoader = ({
  children,
  ...restProps
}: ChkGenericLoaderProps) => {
  return (
    <StyledChkStatusScreen animation="loading" loop {...restProps}>
      {children}
    </StyledChkStatusScreen>
  );
};

const StyledChkStatusScreen = styled(ChkStatusScreen)(() => ({
  minHeight: '100vh',
}));
